<script>
import axios from 'axios';
import findIndex from 'lodash/findIndex';
import {mapState} from 'vuex';

export default {
  props: {
    productGroups: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      warehouses: [],
      lastProductId: null,
      isBaseProduct: true,
      productBtoLeadTime: null,
    };
  },

  computed: {
    btoLeadTime() {
      let btoLeadTime = this.bp('btoLeadTime');

      if (this.productBtoLeadTime && btoLeadTime && btoLeadTime.length) {
        return btoLeadTime.replace('{0}', this.productBtoLeadTime);
      }

      return false;
    },

    ...mapState('pdp', ['pdpSku']),
    ...mapState('backend', ['isB2BPurchasable']),
  },

  watch: {
    pdpSku() {
      if (this.lastProductId !== this.pdpSku) {
        this.retrieveWarehouses(this.pdpSku);
      }
    },
  },

  created() {
    let productId = this.getProductIdFromUrl();

    if (productId) {
      this.retrieveWarehouses(productId);
    }
  },

  methods: {
    retrieveWarehouses(productId) {
      this.lastProductId = productId;
      axios.get('/p/availability/' + productId + '/').then(({data}) => {
        if (data) {
          this.warehouses = data.warehouses;
          this.isBaseProduct = data.isBaseProduct;
          this.productBtoLeadTime = data.btoLeadTime;

          this.$emit('availability-change', data.isPurchasableB2B);
          this.$emit('is-base-product', this.isBaseProduct);
        }
      });
    },

    isBTO(sku) {
      for (let productGroup of this.productGroups || []) {
        let productItem = (productGroup.products || [])
          .filter((product) => product.sku === sku)
          .map((product) => product.isBTO);
        if (productItem.length) {
          return productItem[0];
        }
      }

      return false;
    },

    getETALabel(warehouse) {
      if (this.isBTO(this.pdpSku)) {
        if (!this.isB2BPurchasable) {
          return this.bp('soldOut');
        } else {
          return this.bp('bto');
        }
      } else if (warehouse.futureDate) {
        return warehouse.futureDate;
      } else if (warehouse.soldOut) {
        return this.bp('soldOut');
      }

      return this.bp('noEta');
    },

    getProductIdFromUrl() {
      let pathArray = window.location.pathname.split('/');
      let index = findIndex(pathArray, (x) => x == 'p');

      if (index > -1 && pathArray.length > index + 1) {
        return pathArray[index + 1];
      }

      return null;
    },

    hasWarehouses() {
      return this.warehouses && this.warehouses.length > 0;
    },

    getWarehouseLevel(warehouse) {
      const defaultLevel = 'zero';

      if (warehouse && warehouse.stockLevelLabel) {
        return warehouse.stockLevelLabel;
      }

      return defaultLevel;
    },
  },
};
</script>
